// extracted by mini-css-extract-plugin
export default {"CardTable":"CardTable_CardTable__lW5Hu"};